import signinSet from '../components/signinSet.vue';
import Counter from '../components/counter.vue';
import signinResult from '../components/signinResult.vue';
import cancelHandle from '../components/cancelHandle.vue';
import { useSignServer, useChatServer } from 'middle-domain';
export default {
  components: {
    signinSet,
    Counter,
    signinResult,
    cancelHandle
  },
  data() {
    return {
      signVisible: false,
      signinDown: false,
      // 是否显示签到倒计时
      signInfo: null,
      remaining: 0,
      // 总时长
      timer: null,
      totalTime: 0,
      signId: '',
      // 签到ID
      nowSignObj: '',
      // 当前自动签到信息
      pushTime: '' //定时签到推送时间
    };
  },
  computed: {
    // 总时间
    total() {
      const { duration, autoSign, interval } = this.signInfo;
      return autoSign ? interval : duration;
    },
    // 签到现在的剩余的时间
    starting() {
      return this.signInfo !== null && !!this.remaining;
    },
    // 签到信息是否显示
    showSet() {
      return this.signInfo === null;
    },
    // 签到结果
    showResult() {
      return (
        this.signInfo !== null &&
        !this.remaining &&
        !this.signInfo.autoSign &&
        this.signInfo.push_status != 0
      );
    },
    roomId() {
      return this.$domainStore.state.roomBaseServer.watchInitData.interact.room_id;
    }
  },
  methods: {
    handleSign(flag) {
      flag ? this.openSign() : this.closeSign();
    },
    openSign() {
      // 是否发起了签到
      this.getSignInfo();
    },
    closeSign() {
      this.signVisible = false;
    },
    getSignInfo() {
      this.signServer
        .getSignInfo({
          room_id: this.roomId
        })
        .then(res => {
          if (res.data.id) {
            if (res.data.push_type == 1 && res.data.push_status == 0) {
              this.signInfo = res.data;
              this.signVisible = false;
              this.signinDown = true;
              this.pushTime = res.data.push_time;
              return;
            } else if (res.data.push_type == 1 && res.data.push_status == 1) {
              this.signVisible = false;
              this.pushTime = '';
            }
            this.signinDown = true;
            this.signInfo = res.data;
            this.signId = res.data.id;
            this.nowSignObj = res.data;
            this.signInfo.autoSign = res.data.is_auto_sign == 1;
            this.$set(this.signInfo, 'signTip', res.data.sign_tips);
            if (res.data.is_auto_sign == 1) {
              window.sessionStorage.setItem('isAutoSign', 'true');
              this.remaining = res.data.auto_sign_time_ttl;
              this.signInfo.interval = res.data.auto_sign_time;
              this.totalTime = res.data.auto_sign_time;
            } else {
              this.signInfo.duration = res.data.show_time;
              this.remaining = res.data.sign_time_ttl;
              this.totalTime = 0;
            }
            this.setIntervalAction();
          } else {
            this.signInfo = null;
            this.signVisible = true;
            this.remaining = 0;
            this.timer && clearInterval(this.timer);
            this.signinDown = false;
          }
        })
        .catch(res => {
          this.$message.error(res.msg);
        });
    },
    // 倒计时
    setIntervalAction() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (--this.remaining <= 0) {
          if (sessionStorage.getItem('isAutoSign')) {
            this.remaining = this.totalTime;
            this.signVisible = false;
            this.signinDown = true;
          } else {
            clearInterval(this.timer);
          }
        }
      }, 1000);
      this.$once('hook:beforeDestory', () => {
        clearInterval(this.timer);
      });
    },
    // 开始签到按钮
    startSign(state) {
      const _data = {
        room_id: this.roomId,
        sign_tips: state.signTip,
        // 签到提示语
        show_time: state.duration,
        // 签到显示的时间，单位秒，默认30
        is_auto_sign: Number(state.autoSign),
        // 是否自动发起签到，1自动，0取消自动，默认0
        auto_sign_time: state.interval,
        // 自动发起签到的轮询定时时间，单位秒
        auto_kick_unsigned: state.auto_kick_unsigned,
        // 是否自动踢出未签到用户，1是，0否，默认0
        sign_in_success_tips: state.signInsuccessTips,
        push_type: state.pushType,
        push_time: state.pushTime,
        sound_status: state.sound_status
      };
      this.signServer.signStart(_data).then(res => {
        if (res.code == 200) {
          if (state.pushType == 1) {
            this.getSignInfo();
            return;
          }
          if (state.autoSign) {
            this.totalTime = state.interval;
            window.sessionStorage.setItem('isAutoSign', 'true');
          }
          this.reportSign(state);
          this.signinDown = true;
          this.signVisible = false;
          this.signId = res.data.id;
          this.setSignState({
            signInfo: state
          });
          // this.setIntervalAction();
          // this.getSignInfo();
          window.VhallDataAgent.track('interact_publish_response', {
            button_type: 'sign_in',
            button_biz_id: res.data.id,
            is_success: 1
          });
        } else if (res.code == 513204) {
          // 当前活动已签到中！
          this.openSign();
        } else {
          this.$message.error(res.msg);
        }
        if (res.code != 200) {
          window.VhallDataAgent.track('interact_publish_response', {
            button_type: 'sign_in',
            button_biz_id: res.data.id,
            is_success: 0,
            fail_reason: res.code
          });
        }
      });
    },
    // 数据埋点
    reportSign(state) {
      window.vhallReportForProduct && window.vhallReportForProduct.report(110039);
      window.vhallReportForProduct &&
        window.vhallReportForProduct.report(state.autoSign ? 110040 : 110041);
      if (state.signTip != '主持人发起了签到') {
        window.vhallReportForProduct && window.vhallReportForProduct.report(110042);
      }
      const duration = [10, 30, 60, 120, 180];
      const index = duration.indexOf(state.duration);
      const signType = [110043, 110044, 110045, 110046, 110047];
      window.vhallReportForProduct && window.vhallReportForProduct.report(signType[index]);
      if (state.autoSign) {
        const interval = [60, 300, 900, 1800];
        const indexs = interval.indexOf(state.interval);
        const intervalType = [110048, 110049, 110050, 110051];
        window.vhallReportForProduct && window.vhallReportForProduct.report(intervalType[indexs]);
      }
    },
    // 结束签到
    endSignServe() {
      this.signServer
        .signClose({
          room_id: this.roomId,
          sign_id: this.nowSignObj.id
        })
        .then(res => {
          this.$message.success(`${this.$t('host.k_597001')}`);
          window.sessionStorage.removeItem('isAutoSign');
          if (this.signInfo.autoSign) {
            this.signVisible = false;
            this.signinDown = false;
            this.signInfo = null;
            if (this.isLeleMode) {
              this.openSign();
            }
          }
          this.remaining = 0;
          this.timer && clearInterval(this.timer);
        })
        .catch(err => {
          this.$message.error(err.msg);
        });
    },
    // 设置签到信息和状态
    setSignState(state) {
      this.signInfo = state.signInfo;
      this.remaining = state.remaining ? state.remaining : this.total;
    },
    // 开始签到时先判断是否已经存在签到
    resetSignState() {
      this.getSignInfo();
    },
    // 关闭签到
    closeAutoSignin(form) {
      if (form == 'client') {
        // 客户端走的方法
        this.signVisible = false;
        return;
      }
      this.$vhConfirm(
        this.signInfo.autoSign ? `${this.$t('host.k_597002')}` : `${this.$t('host.k_597003')}`,
        `${this.$t('host.k_597004')}`,
        {
          confirmButtonText: `${this.$t('host.k_597005')}`,
          cancelButtonText: `${this.$t('host.k_597006')}`,
          roundButton: true
        }
      )
        .then(() => {
          this.endSignServe();
        })
        .catch(() => {});
    },
    // 签到推送处理
    handleSigninPush(e) {
      this.getSignInfo();
      const data = {
        roleName: e.data.role_name,
        nickname: e.data.sign_creator_nickname,
        avatar: '//cnstatic01.e.vhall.com/static/images/watch/system.png',
        content: {
          text_content: `${this.$t('chat.chat_1027')}`
        },
        type: e.data.type,
        interactStatus: true
      };
      useChatServer().addChatToList(data);
    },
    // 签到结束处理
    handleSignEnd(e) {
      window.sessionStorage.removeItem('isAutoSign');
      // this.signInfo.autoSign = 0;
      this.remaining = 0;
      clearInterval(this.timer);
      const data = {
        roleName: e.data.role_name,
        nickname: e.data.sign_creator_nickname,
        avatar: '//cnstatic01.e.vhall.com/static/images/watch/system.png',
        content: {
          text_content: `${this.$t('chat.chat_1028')}`
        },
        type: e.data.type,
        interactStatus: true
      };
      useChatServer().addChatToList(data);
    },
    // 直播结束处理
    handleLiveOver() {
      this.signVisible = false;
      this.signinDown = false;
      if (this.timer) {
        clearInterval(this.timer);
      }
      if (this.isLeleMode) {
        this.openSign();
      }
    },
    delSign() {
      this.signServer
        .delSign({
          room_id: this.roomId,
          sign_ids: this.signInfo.id
        })
        .then(res => {
          if (res.code == 200) {
            this.$message.success(`${this.$t('host.k_597007')}`);
            this.pushTime = '';
            this.signinDown = false;
            if (this.isLeleMode) {
              this.openSign();
            }
          }
        });
    }
  },
  beforeCreate() {
    this.signServer = useSignServer();
  },
  mounted() {
    this.signServer.$on('sign_in_push', this.handleSigninPush);
    this.signServer.$on('sign_end', this.handleSignEnd);
    this.signServer.$on('live_over', this.handleLiveOver);
  },
  beforeDestroy() {
    this.signServer.$off('sign_in_push', this.handleSigninPush);
    this.signServer.$off('sign_end', this.handleSignEnd);
    this.signServer.$off('live_over', this.handleLiveOver);
  }
};
